import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=b49ca2b8&scoped=true&"
import script from "./SearchBar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=b49ca2b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49ca2b8",
  null
  
)

export default component.exports